/* eslint import/prefer-default-export: 0 */

/**
 * Defines default value for when a field is invalid
 * @type string
 */
export const DEFAULT_MESSAGE = 'Valid entry required';



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/validator-constants.js